import { render, staticRenderFns } from "./subsidiary-form.vue?vue&type=template&id=052b63a7&scoped=true&"
import script from "./subsidiary-form.vue?vue&type=script&lang=js&"
export * from "./subsidiary-form.vue?vue&type=script&lang=js&"
import style0 from "./subsidiary-form.vue?vue&type=style&index=0&id=052b63a7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052b63a7",
  null
  
)

export default component.exports